import React from "react";

const ExerciseComplted = () => {
  return <div>ExerciseComplted</div>;
};

export default ExerciseComplted;
